import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SpHeaderComponent } from './header/sp-header.component';
import { SectorSwitcherComponent } from './sector/sector-switcher.component';
import { HasFeatureDirective } from './sector/has-feature.directive';

@NgModule({
  declarations: [
    SpHeaderComponent,
    SectorSwitcherComponent,
    HasFeatureDirective
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    SpHeaderComponent,
    SectorSwitcherComponent,
    HasFeatureDirective
  ]
})
export class SpSharedModule {}